import { ServiceModel } from './service.model';

export interface CategoryModel {
  _id: string;
  key: string;
  label: string;
  iconUrl: string;
  coverUrl: string;
  sort?: number;
}

export interface CategoryWithServicesModel {
  _id: string;
  key: string;
  label: string;
  iconUrl: string;
  coverUrl: string;
  services: ServiceModel[];
}
